import React from 'react';
import Alert from '@mui/material/Alert';

const Warning = ({ message }) => <Alert severity='warning'>{message}</Alert>;

export default Warning;
